module.exports = __webpack_public_path__ + "static/media/AW_56_Burger_mobile_hero_fr.30be5051.jpg";